import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  fr: {
    translation: frTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    debug: false,

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    detection: {
      // Saved choice only; first-time visitors get the fallback (en)
      order: ['localStorage'],
      lookupLocalStorage: 'um-tools-language',
      caches: ['localStorage'],
    },
  });

export default i18n;

export {}; // This makes the file a module
